// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-6c8ba2e4]{width:100%;min-width:31.25rem;overflow-x:auto}.table table[data-v-6c8ba2e4]{width:100%}.table th[data-v-6c8ba2e4]{text-align:left}.table th[data-v-6c8ba2e4],.table td[data-v-6c8ba2e4]{padding:0.5rem}a[data-v-6c8ba2e4]{color:#ff038b}h1[data-v-6c8ba2e4],h2[data-v-6c8ba2e4],h3[data-v-6c8ba2e4],h4[data-v-6c8ba2e4],h5[data-v-6c8ba2e4]{margin-bottom:.5em}", ""]);
// Exports
module.exports = exports;
